import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-333af5b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex toolbar justify-content-between mb-3" }
const _hoisted_3 = { class: "col d-flex align-items-end" }
const _hoisted_4 = { class: "row datePicker" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("From")
const _hoisted_6 = { class: "row datePicker" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("To")
const _hoisted_8 = { style: {"align-items":"flex-end"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Apply")
const _hoisted_10 = { class: "d-flex align-items-end" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Export ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_13 = { style: {"margin-bottom":"2rem"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Start time"),
    /*#__PURE__*/_createElementVNode("th", null, "End time")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Before Lunch", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "After Lunch", -1))
const _hoisted_17 = { class: "px-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " please enter your time in increments of 15 minutes, so 1 hour 15 minutes is 1.25 hours ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Production")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collect-hours" }, [
  /*#__PURE__*/_createElementVNode("div", null, " "),
  /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Printing (hrs)")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Dispatch (hrs)")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-question" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin-top":"32px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Other activities")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "collect-other-hours" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Task (hrs)")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Task (hrs)")
    ])
  ])
], -1))
const _hoisted_27 = { class: "collect-other-hours" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-question" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" reported in total ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Other"),
  /*#__PURE__*/_createElementVNode("p", null, "Includes:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Bulk dispatch (prepacked US) "),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, " Specifically the boxing up of the prepacked envelopes. In other words the individual packing of an order is recorded as Dispatch. But the group boxing up and booking with DHL is not. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Bulk Dispatch (Ctype) "),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, " Specifically the boxing up of grouped Ctype orders to ship to the US and the booking of that manually in DHL. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "Helping on Front desk"),
    /*#__PURE__*/_createElementVNode("li", null, "Cleaning a printer"),
    /*#__PURE__*/_createElementVNode("li", null, "Fixing a printer"),
    /*#__PURE__*/_createElementVNode("li", null, "Fixing a computer"),
    /*#__PURE__*/_createElementVNode("li", null, "Working through a software issue"),
    /*#__PURE__*/_createElementVNode("li", null, "Magnum label counting"),
    /*#__PURE__*/_createElementVNode("li", null, "Magnum label printing"),
    /*#__PURE__*/_createElementVNode("li", null, "Magnum print proofing"),
    /*#__PURE__*/_createElementVNode("li", null, "Magnum bulk dispatch and palette packing/shipping"),
    /*#__PURE__*/_createElementVNode("li", null, " (US) Taking the USPS parcels down to the loading bay and waiting for USPS "),
    /*#__PURE__*/_createElementVNode("li", null, "Working with an artist in the hand signing process"),
    /*#__PURE__*/_createElementVNode("li", null, "Packaging and shipping bulk printed prints to other branches")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_label = _resolveComponent("k-label")!
  const _component_k_date_picker = _resolveComponent("k-date-picker")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_k_time_picker = _resolveComponent("k-time-picker")!
  const _component_k_numeric_text_box = _resolveComponent("k-numeric-text-box")!
  const _component_k_dialog_action_bar = _resolveComponent("k-dialog-action-bar")!
  const _component_k_dialog = _resolveComponent("k-dialog")!
  const _component_production_team_grid = _resolveComponent("production-team-grid")!
  const _component_k_tab_strip_tab = _resolveComponent("k-tab-strip-tab")!
  const _component_k_tab_strip = _resolveComponent("k-tab-strip")!
  const _component_k_window = _resolveComponent("k-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_k_label, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_k_date_picker, {
            id: "startDateDatePicker",
            modelValue: _ctx.startDateRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDateRef) = $event)),
            format: 'yyyy-MM-dd',
            min: new Date(2024, 4, 1),
            max: _ctx.tomorrow
          }, null, 8, ["modelValue", "min", "max"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_k_label, null, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_k_date_picker, {
            id: "endDateDatePicker",
            modelValue: _ctx.endDateRef,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDateRef) = $event)),
            format: 'yyyy-MM-dd',
            min: new Date(2024, 4, 1),
            max: _ctx.tomorrow
          }, null, 8, ["modelValue", "min", "max"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_k_button, { onClick: _ctx.onApplyDateRangeButton }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_k_button, { onClick: _ctx.onExportClick }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.isVisibleDialog)
      ? (_openBlock(), _createBlock(_component_k_dialog, {
          key: 0,
          title: 'Fill working time',
          onClose: _ctx.toggleDialog
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.currentAttendance.FullName), 1),
                _hoisted_12,
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDateForDialog(_ctx.currentAttendance)), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("table", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_15,
                      _createElementVNode("td", null, [
                        _createVNode(_component_k_time_picker, {
                          value: _ctx.currentAttendance.StartTimeBeforeLunch,
                          format: 'HH:mm',
                          steps: _ctx.steps,
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDateChange($event, 'StartTimeBeforeLunch')))
                        }, null, 8, ["value", "steps"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_k_time_picker, {
                          value: _ctx.currentAttendance.EndTimeBeforeLunch,
                          format: 'HH:mm',
                          steps: _ctx.steps,
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDateChange($event, 'EndTimeBeforeLunch')))
                        }, null, 8, ["value", "steps"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_16,
                      _createElementVNode("td", null, [
                        _createVNode(_component_k_time_picker, {
                          value: _ctx.currentAttendance.StartTimeAfterLunch,
                          format: 'HH:mm',
                          steps: _ctx.steps,
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDateChange($event, 'StartTimeAfterLunch')))
                        }, null, 8, ["value", "steps"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_k_time_picker, {
                          value: _ctx.currentAttendance.EndTimeAfterLunch,
                          format: 'HH:mm',
                          steps: _ctx.steps,
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDateChange($event, 'EndTimeAfterLunch')))
                        }, null, 8, ["value", "steps"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _hoisted_20,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productionActivities(
              _ctx.currentAttendance.Breakdown,
            ), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "collect-hours"
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_k_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.workbreakdownTitle(item)), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _hoisted_21,
                      (_ctx.isOther(item.ClientReference))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleInfo && _ctx.toggleInfo(...args)))
                          }, _hoisted_23))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_k_numeric_text_box, {
                        modelValue: item.PrintingHours,
                        "onUpdate:modelValue": ($event: any) => ((item.PrintingHours) = $event),
                        placeholder: 'hours',
                        min: 0,
                        max: 24,
                        format: 'n2',
                        step: 0.25
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.hasPrintingAndDispatch(item.ClientReference))
                        ? (_openBlock(), _createBlock(_component_k_numeric_text_box, {
                            key: 0,
                            modelValue: item.DispatchHours,
                            "onUpdate:modelValue": ($event: any) => ((item.DispatchHours) = $event),
                            placeholder: 'hours',
                            min: 0,
                            max: 24,
                            format: 'n2',
                            step: 0.25
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, " "))
                    ])
                  ]))
                }), 128)),
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherActivities(
                _ctx.currentAttendance.Breakdown,
              ), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "collect-other-hours"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({ 'with-padding': ((index % 2) != 0) })
                      }, [
                        _createVNode(_component_k_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.workbreakdownTitle(item)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_ctx.isOther(item.ClientReference))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleInfo && _ctx.toggleInfo(...args)))
                            }, _hoisted_29))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", null, [
                        _createVNode(_component_k_numeric_text_box, {
                          modelValue: item.PrintingHours,
                          "onUpdate:modelValue": ($event: any) => ((item.PrintingHours) = $event),
                          placeholder: 'hours',
                          min: 0,
                          max: 24,
                          format: 'n2',
                          step: 0.25
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatMinutesToHours(_ctx.totalMinutes)), 1),
                  _hoisted_30
                ])
              ])
            ]),
            _createVNode(_component_k_dialog_action_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  style: {"background-color":"#70c47a"},
                  onClick: _ctx.saveWorkingTime
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, {
                  style: {"background-color":"#c04246","color":"white"},
                  onClick: _ctx.removeWorkingTime
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, { onClick: _ctx.toggleDialog }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_k_tab_strip, {
      selected: _ctx.selectedTab,
      onSelect: _ctx.onSelectedTab
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock(_component_k_tab_strip_tab, {
            key: tab.id,
            title: tab.title
          }, {
            default: _withCtx(() => [
              (_ctx.selectedTab === tab.id)
                ? (_openBlock(), _createBlock(_component_production_team_grid, {
                    key: 0,
                    isGridInitialized: tab.isGridInitialized,
                    "onUpdate:isGridInitialized": ($event: any) => ((tab.isGridInitialized) = $event),
                    url: tab.url,
                    "grid-id": tab.gridId,
                    "branch-name": tab.branchName,
                    "additional-data-function-name": tab.additionalDataFunctionName,
                    "additional-data": tab.additionalData
                  }, null, 8, ["isGridInitialized", "onUpdate:isGridInitialized", "url", "grid-id", "branch-name", "additional-data-function-name", "additional-data"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["selected", "onSelect"]),
    (_ctx.isVisibleInfo)
      ? (_openBlock(), _createBlock(_component_k_window, {
          key: 1,
          class: "info-window",
          title: 'Info',
          "maximize-button": () => null,
          "minimize-button": () => null,
          "initial-height": 650,
          "initial-width": 500,
          "initial-top": 100,
          onClose: _ctx.toggleInfo
        }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }, 8, ["maximize-button", "minimize-button", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}